import DocumentPreview from './document-preview';

export default DocumentPreview;